{
  "title": "Spider Climb",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a drop of bitumen and a spider)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "Until the spell ends, one willing creature you touch gains the ability to move up, down, and across vertical surfaces and upside down along ceilings, while leaving its hands free. The target also gains a climbing speed equal to its walking speed."
  ],
  "spellLists": ["artificer", "sorcerer", "warlock", "wizard"]
}
